module.exports = __webpack_public_path__ + "static/media/Dashboard.4cf34a11.svg";